import React from "react";
import styles from "./Results.module.scss";
import { ResultsProps } from "./Results.interface";
import { LS_CONFIG, LS_NAME } from "../../Static/consts";
import { ILs } from "../../entities/ILs";
import convertSecToTime from "../../Utils/convertSecToTime";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { Button } from "..";

export const Results: React.FC<ResultsProps> = (props) => {
  const { onClose } = props;
  const { words } = useSelector((state: RootState) => state.game);
  let results: ILs[] | undefined;
  const lsResults = localStorage.getItem(LS_NAME);
  if (lsResults) {
    results = JSON.parse(lsResults);
  }

  const onRestart = () => {
    localStorage.removeItem(LS_NAME);
    if (words) {
      localStorage.setItem(LS_CONFIG, JSON.stringify({ isFirstGame: false }));
      window.location.reload();
    }
  };

  return (
    <div className={styles.results}>
      <div className={styles.formClose} onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
        >
          <path
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="m4.757 4.757 8.486 8.486M4.757 13.243l8.486-8.486"
          />
        </svg>
      </div>
      <div className={styles.caption}>Результаты</div>
      <div className={styles.message}>
        {results
          ? results.map((item) => (
              <div className={styles.resultsWrap} key={item.word}>
                <div className={styles.word}>Слово: «{item.word}»</div>
                <div className={styles.isWin}>
                  {item.isWin ? "Отгадал" : "Не отгадал"}
                </div>
                <div className={styles.time}>
                  {convertSecToTime(+item.time)}
                </div>
                <div></div>
              </div>
            ))
          : "Нет результатов"}
      </div>
      <Button title="Начать заново" onClick={onRestart} />
    </div>
  );
};
